import { generateKeys } from '../utils';
export const vpsSubscriptionStatuses = generateKeys({
    new: {
        value: 'new',
        label: 'New',
    },
    pending: {
        value: 'pending',
        label: 'Pending',
    },
    active: {
        value: 'active',
        label: 'Active',
    },
    suspended: {
        value: 'suspended',
        label: 'Suspended',
    },
    deleted: {
        value: 'deleted',
        label: 'Deleted',
    },
    failed: {
        value: 'failed',
        label: 'Failed',
    },
});
export const vpsSubscriptionTypes = generateKeys({
    free: {
        value: 'free',
        label: 'Free',
    },
    paid: {
        value: 'paid',
        label: 'Paid',
    },
});
export const vpsSubscriptionBillingCycles = generateKeys({
    monthly: {
        value: 'm',
        label: 'Monthly',
    },
});
export const vpsSubscriptionPaymentMethods = generateKeys({
    card: {
        value: '90',
        label: 'Credit / Debit Card (JCC)',
    },
    paypal: {
        value: '8',
        label: 'PayPal',
    },
    banktransfer: {
        value: '6',
        label: 'BankTransfer',
    },
});
export const vpsSubscriptionPlans = generateKeys({
    basic: {
        value: 'basic',
        order: 1,
        planCode: 'vps-basic',
        label: 'VPS Basic',
        productCode: '1591',
        currency: 'EUR',
        defaultAmount: 30,
        features: { one_core: 'done', disk_space_40: 'done', memory_1gb: 'done', os_windows: 'done' },
        isFree: ['raw_pro'],
        enabled: true,
    },
    advanced: {
        value: 'advanced',
        order: 2,
        planCode: 'vps-advanced',
        label: 'VPS Advanced',
        productCode: '1586',
        currency: 'EUR',
        defaultAmount: 50,
        features: { two_core: 'done', disk_space_50: 'done', memory_2gb: 'done', os_windows: 'done' },
        isFree: [],
        enabled: true,
    },
    pro: {
        value: 'pro',
        order: 3,
        planCode: 'vps-pro',
        label: 'VPS Pro',
        productCode: '1587',
        currency: 'EUR',
        defaultAmount: 70,
        features: { four_core: 'done', disk_space_100: 'done', memory_4gb: 'done', os_windows: 'done' },
        isFree: [],
        enabled: true,
    },
});
export const vpsVMActions = generateKeys({
    details: {
        value: '',
        label: 'Details',
        enabled: true,
        i18n: 'details',
        icon: 'details',
        order: 1,
    },
    start: {
        value: 'start',
        label: 'Start',
        enabled: true,
        i18n: 'vpsServerStart',
        icon: 'start',
        order: 2,
    },
    stop: {
        value: 'stop',
        label: 'Stop',
        enabled: true,
        i18n: 'vpsServerStop',
        icon: 'stop',
        order: 3,
    },
    reboot: {
        value: 'reboot',
        label: 'Reboot',
        enabled: true,
        i18n: 'vpsServerReboot',
        icon: 'reboot',
        order: 4,
    },
    resetPassword: {
        value: 'resetpwd',
        label: 'Reset Password',
        enabled: true,
        i18n: 'resetPassword',
        icon: 'reset-password',
        order: 5,
    },
});
export const vpsServerStatuses = generateKeys({
    running: {
        label: 'Running',
        value: 1,
        enabled: true,
        i18n: 'vpsServerRunning',
        icon: 'running',
        order: 1,
    },
    stopped: {
        label: 'Stopped',
        value: 0,
        enabled: true,
        i18n: 'vpsServerStopped',
        icon: 'stopped',
        order: 2,
    },
});
